var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7628 2.91016C9.45276 2.91016 6.76276 5.60016 6.76276 8.91016V11.8002C6.76276 12.4102 6.50276 13.3402 6.19276 13.8602L5.04276 15.7702C4.33276 16.9502 4.82276 18.2602 6.12276 18.7002C10.4328 20.1402 15.0828 20.1402 19.3928 18.7002C20.6028 18.3002 21.1328 16.8702 20.4728 15.7702L19.3228 13.8602C19.0228 13.3402 18.7628 12.4102 18.7628 11.8002V8.91016C18.7628 5.61016 16.0628 2.91016 12.7628 2.91016Z",
    stroke: "#242525",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7637,
    cy: 5.93994,
    r: 4,
    fill: "#12D6B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6131 3.19994C14.3031 3.10994 13.9831 3.03994 13.6531 2.99994C12.6931 2.87994 11.7731 2.94994 10.9131 3.19994C11.2031 2.45994 11.9231 1.93994 12.7631 1.93994C13.6031 1.93994 14.3231 2.45994 14.6131 3.19994Z",
    stroke: "#242525",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7627 19.0601C15.7627 20.7101 14.4127 22.0601 12.7627 22.0601C11.9427 22.0601 11.1827 21.7201 10.6427 21.1801C10.1027 20.6401 9.7627 19.8801 9.7627 19.0601",
    stroke: "#242525",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.63e0bcbd7fb95c9c80e0741894e40938.svg";
export { ForwardRef as ReactComponent };